import { Component, Input, HostBinding } from '@angular/core';

import { Locale, LocaleDataService } from '../core';

@Component({
  selector: 'atn-current-locale-code',
  templateUrl: './current-locale-code.component.html',
  styleUrls: ['./current-locale-code.component.scss'],
  host: {
    'matSuffix': 'matSuffix'
  }

})
export class CurrentLocaleCodeComponent {

  locale: Locale;

  constructor(
    private localeDataService: LocaleDataService
  ) {
    this.locale = this.localeDataService.getCurrentLocale();
  }

}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/current-locale-code/current-locale-code.component.ts